// src/utils/setProdOrDev.js

const normalizeChatApiUrl = (rawUrl) => {
    const trimmedUrl = typeof rawUrl === 'string' && rawUrl.trim() ? rawUrl.trim() : '';
    if (!trimmedUrl) {
        return null;
    }

    if (trimmedUrl.startsWith('/')) {
        return trimmedUrl.replace(/\/+$/, '') || '/api';
    }

    const withoutTrailingSlash = trimmedUrl.replace(/\/+$/, '');
    return /\/api$/i.test(withoutTrailingSlash)
        ? withoutTrailingSlash
        : `${withoutTrailingSlash}/api`;
};

const DEV_CHAT_API_URL = 'http://127.0.0.1:18888/api';

const getRuntimeChatApiUrl = () => {
    const configuredUrl = normalizeChatApiUrl(import.meta.env.VITE_CHAT_API_URL);
    if (configuredUrl) {
        return configuredUrl;
    }

    if (import.meta.env.DEV) {
        return DEV_CHAT_API_URL;
    }

    if (typeof window !== 'undefined' && window.location?.origin) {
        return `${window.location.origin}/api`;
    }

    return '/api';
};

// EXPORT 1: The centralized runtime config for V5.
export const config = {
    chatApiUrl: getRuntimeChatApiUrl(),
};

// EXPORT 2: The original function for backward compatibility with existing files (e.g., timestampService.js)
export const getApiBaseUrl = () => {
    return config.chatApiUrl;
};

export const getApiRootUrl = () => {
    return config.chatApiUrl.replace(/\/api$/, '');
};

export const isWorkspaceBackendEnabled = () => {
    return Boolean(config.chatApiUrl);
};

export const isTerminalV2Enabled = () => {
    const explicitFlag = String(import.meta.env.VITE_TERMINAL_V2_ENABLED || '').trim().toLowerCase();
    if (explicitFlag === 'true') {
        return true;
    }
    if (explicitFlag === 'false') {
        return false;
    }

    return Boolean(import.meta.env.DEV);
};